<template>
    <ValidationObserver v-slot="{ handleSubmit }" slim ref="selected">
        <!-- <BackButton /> -->
        <form @submit.prevent="handleSubmit(addAttendance())" class="checkinout-form">

            <div class="checkinout-header">
                <img class="checkinout-logo" src="/assets/layout/images/logo.svg" alt="ProAstra">
            </div>

            <div class="checkinout-details">
                <div class="checkout-detailsform">

                    <!-- ASSET DETAILS -->
                    <div v-if="isCheckedIn() && isAsset()">
                        <h3 :class="successClass">{{ detailsHeader }}</h3>
                        <ul class="asset_details" v-if="isOnline == true">
                            <li><span>Company</span><span>{{ offlineAssets.client_name }}</span></li>
                            <li><span>Site</span><span>{{ offlineAssets.site_name }}</span></li>
                            <hr>
                            <li><span>Name</span><span>{{ asset.name }}</span></li>
                            <li><span>Type</span><span>{{ asset.asset_type }}</span></li>
                            <li><span>Area</span><span>{{ asset.area }}</span></li>
                            <li><span>Sub-Area</span><span>{{ asset.location }}</span></li>
                            <li><span>ID</span><span>{{ forceFourDigits(asset.asset_id) }}</span></li>
                            <li v-if="asset.asset_type == 'Asset'"><span>Category</span><span>{{ asset.category
                            }}</span></li>
                            <li v-if="asset.asset_type == 'Asset'"><span>Make</span><span>{{ asset.make }}</span></li>
                            <li v-if="asset.asset_type == 'Asset'"><span>Model</span><span>{{ asset.model }}</span></li>
                            <li><span>Description</span><span>{{ asset.description }}</span></li>
                            <li v-if="postedNotes"><span>Notes</span><span>{{ postedNotes }}</span></li>
                        </ul>
                        <ul class="asset_details" v-else>
                            <li><span>Company</span><span>{{ offlineAssets.client_name }}</span></li>
                            <li><span>Site</span><span>{{ offlineAssets.site_name }}</span></li>
                            <hr>
                            <li><span>Name</span><span>{{ offlineAssets.name }}</span></li>
                            <li><span>Type</span><span>{{ offlineAssets.asset_type }}</span></li>
                            <li><span>Area</span><span>{{ offlineAssets.area }}</span></li>
                            <li><span>Sub-Area</span><span>{{ offlineAssets.location }}</span></li>
                            <li><span>ID</span><span>{{ forceFourDigits(offlineAssets.asset_id) }}</span></li>
                            <li v-if="offlineAssets.asset_type == 'Asset'"><span>Category</span><span>{{
                                offlineAssets.category }}</span></li>
                            <li v-if="offlineAssets.asset_type == 'Asset'"><span>Make</span><span>{{ offlineAssets.make
                            }}</span></li>
                            <li v-if="offlineAssets.asset_type == 'Asset'"><span>Model</span><span>{{
                                offlineAssets.model }}</span></li>
                            <li><span>Description</span><span>{{ offlineAssets.description }}</span></li>
                            <li v-if="postedNotes"><span>Notes</span><span>{{ postedNotes }}</span></li>
                        </ul>
                    </div>
                    <!-- ASSET DETAILS END -->

                    <div :class="(isCheckedIn() && isAsset()) ? 'outcome_details' : ''">
                        <h2 v-if="(!isAsset()) || (!isCheckedIn()) || (isAsset() && !isCheckedIn())">
                            Please Check {{ selected.checked.name }}
                        </h2>

                        <!-- CHECK-IN FIELDS -->
                        <ValidationProvider name="Full name" :rules="{ required: true }" v-slot="{ errors }" v-if="(!isAsset()) || (!isCheckedIn()) || (isAsset() && !isCheckedIn())">
                            <div class="p-my-4">
                                <label for="full_name">Full name*</label>
                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" id="full_name" v-model="selected.fullName" />
                                <small id="full_name-help" class="p-error p-d-block" v-if="errors[0]">
                                    {{ errors[0] }}
                                </small>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider name="Company name" :rules="{ required: true }" v-slot="{ errors }" v-if="(!isAsset()) || (!isCheckedIn()) || (isAsset() && !isCheckedIn())">
                            <div class="p-my-4">
                                <label for="company">Company*</label>
                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" id="company" v-model="selected.company" />
                                <small id="company-help" class="p-error p-d-block" v-if="errors[0]">
                                    {{ errors[0] }}
                                </small>
                            </div>
                        </ValidationProvider>
                        <!-- CHECK-IN FIELDS END -->

                        <!-- PASS / FAIL FIELDS -->
                        <div v-if="(isCheckedIn() && isAsset()) && triggerFinish == false" name="Pass or Fail">
                            <h3>Outcome of Task?</h3>

                            <span v-if="maintenanceStatus" class="pass_fail_value" :class="passFail">
                                {{ maintenanceStatus }}
                            </span>

                            <!-- pass/fail buttons -->

                            <div v-if="(passFail == null && FaultStatus == null)">
                                <div class="report__buttons">
                                    <RadioButton id="Pass" value="Pass" v-model="passFail" @click.prevent="maintenanceStatus = 'Passed'" />
                                    <label for="Pass">Pass</label>

                                    <!-- disable the button if the fault is marked as active or in progress, as only 1 fault at a time is allowed -->
                                    <RadioButton id="report_fault" value="active" v-model="FaultStatus" @click.prevent="maintenanceStatus = 'Report Fault'" />
                                    <label for="report_fault">Report Fault</label>

                                    <RadioButton id="Fail" value="Fail" v-model="passFail" @click.prevent="maintenanceStatus = 'Failed'" />
                                    <label for="Fail">Fail</label>

                                    <!-- disable button if the fault is not marked as 'in progress' - 'in progress' can only be set by an admin via the asset page -->
                                    <RadioButton :disabled="(faults.length) ? false : true" id="rectify_fault" value="rectified" v-model="FaultStatus" @click.prevent="maintenanceStatus = 'Rectify Fault'" />
                                    <label :class="(faults.length) ? '' : 'disabled__button'" for="rectify_fault">Rectify Fault</label>
                                </div>

                                <div class="p-d-grid" style="gap: 1rem; display: grid; margin-top: 4rem">
                                    <router-link class="checkinout-submit p-button p-component" to="/scan">Tap NFC/Scan QR Code</router-link>
                                    <a style="cursor: pointer;" v-if="isOnline" class="checkinout-submit p-button p-component" @click.prevent="protectedCheckOut()">Check Out</a>
                                </div>
                            </div>

                            <div v-else>

                                <!-- rectify dropdown -->
                                <div v-if="maintenanceStatus == 'Rectify Fault'">
                                    <span class="p-mb-2 p-d-block">Select Fault to Rectify</span>
                                    <Dropdown v-model="selectedFault" :options="faults" style="width: 100%;" class="p-mb-2" optionLabel="fault_id" :showClear="true">
                                        <template #value="slotProps">
                                            <div class="p-dropdown-value" v-if="slotProps.value">
                                                <strong>Fault {{ slotProps.value.fault_id }}</strong>
                                            </div>
                                            <div v-else>
                                                <span>Select a Fault</span>
                                            </div>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="p-dropdown-option">
                                                <span class="p-d-flex p-jc-between"><strong>Fault {{ slotProps.option.fault_id }}</strong><span>Status: <span class="status__icon" :class="{ 'icon__active': slotProps.option.fault_status == 'active', 'icon__in_progress': slotProps.option.fault_status == 'in_progress' }">{{ setIndividualFaultStatus(slotProps.option.fault_status) }}</span></span></span>
                                                <hr>
                                                <div class="p-d-flex fault_fields" style="flex-direction: column;">
                                                    <small>Reported By:</small>
                                                    <span v-if="slotProps.option.fault_reporter_name"><span><strong>Name:</strong> {{ slotProps.option.fault_reporter_name }}</span></span>
                                                    <span v-if="slotProps.option.fault_reporter_company"><strong>Company:</strong> {{ slotProps.option.fault_reporter_company }}</span>
                                                    <span v-if="slotProps.option.fault_status_timestamp"><strong>Timestamp:</strong> {{ slotProps.option.fault_status_timestamp }}</span>
                                                    <span v-if="slotProps.option.fault_report_note"><strong>Note:</strong> {{ slotProps.option.fault_report_note }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                </div>

                                <label for="notes">Notes</label>
                                <Textarea id="notes" v-model="notes" :autoResize="true" rows="5" />
                            </div>
                            <!-- pass/fail buttons END -->


                        </div>
                        <!-- PASS / FAIL FIELDS END -->

                        <!-- CHECK OUT BUTTON -->
                        <!-- buttons for when online -->
                        <div v-if="triggerFinish == true && isOnline" style="gap: 1rem; display: grid; margin-top: 4rem">
                            <Button label="Check Out" @click.prevent="finishedCheckOut()" class="checkinout-submit p-button p-component" />
                            <Button label="Tap NFC/Scan QR Code." @click.prevent="$router.push('/scan')" class="checkinout-submit p-button p-component" />
                        </div>
                        <!-- buttons for when offline -->
                        <div v-if="triggerFinish == true && !isOnline">
                            <h3 style="text-align: center;">You are offline - please regain connection to check out.</h3>
                            <Button label="Tap NFC/Scan QR Code." @click.prevent="$router.push('/scan')" class="checkinout-submit p-button p-component" />
                        </div>
                        <!-- CHECK OUT BUTTON END -->
                    </div>

                    <!-- SUBMISSION BUTTONS FOR PASS/FAIL-->
                    <div v-if="triggerFinish == false">
                        <div v-if="(!isAsset()) || (!isCheckedIn()) || (isAsset() && !isCheckedIn())">
                            <Button type="button" @click.prevent="addAttendance(), cacheAssets()" :id="(selected.checked.name == 'In') ? 'check_in_cache' : 'nocache'" :label="'Check ' + selected.checked.name" class="checkinout-submit" :disabled="(isOnline) ? false : true" />
                        </div>

                        <!-- online and offline buttons for pass/fail only -->
                        <Button v-if="(passFail !== null && isOnline)" type="button" @click.prevent="triggerFinish = true, addAttendance(false)" label="Submit" class="checkinout-submit" />
                        <Button v-if="(passFail !== null && !isOnline)" type="button" @click.prevent="triggerFinish = true, storeAttendance(false)" label="Offline Submit" class="checkinout-submit" />
                        <!-- --------------------------------------------- -->

                        <!-- online and offline buttons for fault status change -->

                        <Button v-if="(FaultStatus == 'active' && isOnline)" type="button" @click.prevent="triggerFinish = true, addFault()" label="Submit Fault Data" class="checkinout-submit" />
                        <Button v-if="(FaultStatus == 'rectified' && isOnline)" type="button" @click.prevent="triggerFinish = true, updateFaultStatus(selectedFault.key, FaultStatus)" label="Submit Fault Data" class="checkinout-submit" />

                        <Button v-if="(FaultStatus !== null && !isOnline)" type="button" @click.prevent="triggerFinish = true, storeFault(false)" label="Offline Submit Fault Data" class="checkinout-submit" />
                        <!-- --------------------------------------------- -->

                        <small class="p-error p-d-block p-mt-2" v-if="!isOnline && ((!isAsset()) || (!isCheckedIn()) || (isAsset() && !isCheckedIn()))">
                            You are offline - Please regain connection to Check {{ selected.checked.name }}.
                        </small>
                        <span @click.prevent="passFail = null, FaultStatus = null, maintenanceStatus = null" v-if="passFail !== null || FaultStatus !== null" class="p-button-link cancel_button">Back</span>
                    </div>
                    <!-- SUBMISSION BUTTONS END -->

                </div>
            </div>

            <Toast />

        </form>
        <ConfirmDialog></ConfirmDialog>
    </ValidationObserver>


</template>

<script>
import { db } from '@/firebase';
import moment from 'moment';
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import BackButton from '../components/BackButton.vue';
import axios from 'axios';
import { calculateMaintenanceStatus } from '@/utils/maintenanceUtils';

import { extend } from 'vee-validate';
import { required, length, email, integer, max, regex } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: (fieldName) => {
        return `Please enter your ${fieldName.toLowerCase()}`;
    }
});
extend('length', length);
extend('integer', integer);
extend('regex', regex);
extend('max', max);
extend('email', {
    ...email,
    message: 'Please enter a valid email address'
});

import { configure } from 'vee-validate';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
})

export default {
    props: ['isOnline'],
    components: {
        ValidationProvider,
        ValidationObserver,
        BackButton
    },
    data() {
        return {
            siteName: '',
            clientName: '',
            asset: {},
            attendance: {},
            checking: [
                { name: 'In', key: 'in' },
                { name: 'Out', key: 'out' }
            ],
            selected: {
                fullName: null,
                company: null,
                checked: null,
                fault: null
            },
            passFail: null,
            FaultStatus: null,
            maintenanceStatus: null,
            triggerFinish: false,
            notes: '',
            postedNotes: '',
            detailsHeader: 'Details',
            successClass: '',
            offlineAssets: '',
            // triggerScan: false,
            checkOutModal: false,
            faults: [],
            selectedFault: null,
            fault_statuses: [
                { label: 'Fault', value: 'active', hex: '#f31b2b' },
                { label: 'In Progress', value: 'in_progress', hex: '#ffbf00' }
            ],
            siteNameStored: '',
            clientNameStored: 'null'
        }
    },
    created() {
        // stores values from cookies that are used for the attendance log
        if (this.$cookie.get('ProAstra_checkedIn') == '1') {
            this.selected.checked = this.checking[1];
            this.selected.fullName = this.$cookie.get('ProAstra_checkInName');
            this.selected.company = this.$cookie.get('ProAstra_checkInCompany');
        } else {
            this.selected.checked = this.checking[0];
        }
    },
    mounted() {
        this.fetchSiteName();
        this.fetchCompanyName();
        this.fetchCachedData();
        this.updateFaultData();
    },
    firestore() {
        if (this.isOnline) {
            return {
                attendance: db.collection('attendance'),
                asset: db.collection('assets').doc(this.$route.params.asset_id)
            }
        }
    },
    computed: {
        currentStoredData() {
            return JSON.parse(sessionStorage.getItem('stored-maintenance-data'));
        },
        currentStoredAttendance() {
            return JSON.parse(sessionStorage.getItem('stored-attendance-data'));
        },
        currentStoredFaultLog() {
            return JSON.parse(sessionStorage.getItem('stored-fault-log-data'));
        },
        currentStoredFaultData() {
            return JSON.parse(sessionStorage.getItem('stored-fault-asset-data'));
        },
        setIconBg(status) {
            console.log(status)

            return 'blue'
        }
    },
    watch: {
        isOnline(newOnline, oldOnline) {
            if (newOnline == true) {
                console.log('back online');
                this.fetchSiteName();
                this.fetchCompanyName();
                setTimeout(() => {
                    let refetchAsset = db.collection('assets').doc(this.$route.params.asset_id);
                    refetchAsset.get().then((asset) => {
                        this.asset = asset.data();
                    }).catch((error) => {
                        console.error("refetchAsset", error)
                    })

                    let refetchSite = db.collection('sites').doc(this.$route.params.id);
                    refetchSite.get().then((asset) => {
                        this.site = asset.data();
                    }).catch((error) => {
                        console.error("refetchSite", error)
                    })
                }, 500)
            }
        }
    },
    methods: {
        // cancelScan() {
        //     this.triggerScan = false;
        // },
        cacheAssets() {
            if (navigator.serviceWorker.controller) {
                console.log('has worker');
                navigator.serviceWorker.controller.postMessage({ action: 'cache-assets' });
            }
        },
        addAttendance(checkOut) {
            let assets = [];
            let siteId = this.$route.params.id;

            this.notes = this.notes.replaceAll('\n', ' - ');
            this.notes = this.notes.replaceAll(',', ' - ');

            // pushes all asset data to local storage for offline functionality
            if (checkOut != false) {

                if (!assets.length) {
                    assets = db.collection('assets').where('site_id', '==', siteId);
                    this.fetchSiteCompanyData(this.siteName, this.clientName);

                    assets.get().then((assetsSnapshots) => {
                        assets = [];

                        assetsSnapshots.forEach(doc => {
                            var data = doc.data();
                            var key = doc.id;
                            var slimData = {
                                name: data.name,
                                asset_type: data.asset_type,
                                area: data.area,
                                location: data.location,
                                asset_id: data.asset_id,
                                category: data.category,
                                make: data.make,
                                model: data.model,
                                description: data.description,
                                last_maintained_date: data.last_maintained_date,
                                first_maintained_date: data.first_maintained_date,
                                maintenance_schedule_start_date: data.maintenance_schedule_start_date,
                                maintenance_frequency: data.maintenance_frequency,
                                timestamp: data.timestamp,
                                key: key
                            }
                            slimData.site_name = this.siteName;
                            slimData.client_name = this.clientName;
                            assets.push(slimData);

                        });
                        localStorage.setItem('site-asset-data', JSON.stringify(assets));
                    });
                    this.fetchFaultData();
                }

            }

            // adds data to attendance log
            this.$refs.selected.validate().then(success => {

                let currentDate = new Date(),
                    formattedDate = moment(currentDate).format('DD/MM/YYYY @ hh:mma'),
                    assetId = this.$route.params.asset_id,
                    assetIdParsed = (typeof (assetId) !== 'undefined' ? assetId : null),
                    passParsed = (typeof (assetId) !== 'undefined' ? this.passFail : ''),
                    notesParsed = (typeof (assetId) !== 'undefined' ? this.notes : null),
                    metaParsed = (typeof (assetId) !== 'undefined' ? {
                        category: (typeof (this.asset.category) !== 'undefined' ? this.asset.category : ''),
                        make: (typeof (this.asset.make) !== 'undefined' ? this.asset.make : ''),
                        model: (typeof (this.asset.model) !== 'undefined' ? this.asset.model : ''),
                        asset_id: (typeof (this.asset.asset_id) !== 'undefined' ? this.asset.asset_id : ''),
                        description: (typeof (this.asset.description) !== 'undefined' ? this.asset.description : ''),
                        install_date: (typeof (this.asset.install_date) !== 'undefined' ? this.asset.install_date : ''),
                        warranty_expiry_date: (typeof (this.asset.warranty_expiry_date) !== 'undefined' ? this.asset.warranty_expiry_date : ''),
                        area: (typeof (this.asset.area) !== 'undefined' ? this.asset.area : ''),
                        location: (typeof (this.asset.location) !== 'undefined' ? this.asset.location : '')
                    } : null),
                    status = (checkOut == false ? { name: null, key: null } : this.selected.checked);

                if (success) {
                    this.$firestore.attendance.add(
                        {
                            full_name: this.selected.fullName,
                            company: this.selected.company,
                            client_id: this.$route.params.client_id,
                            site_id: this.$route.params.id,
                            site_name: this.siteName,
                            asset_id: assetIdParsed,
                            timestamp: currentDate,
                            datetime: formattedDate,
                            checked: status,
                            fault: this.selected.fault,
                            pass: passParsed,
                            notes: notesParsed,
                            // meta required for CSV export
                            meta: metaParsed
                        }
                    ).then(() => {
                        let storedMaintenanceStatus = null;
                        if (this.$route.params.asset_id) {
                            // Use the utility function to calculate maintenance status
                            const currentTime = moment().unix();
                            
                            // Create a temporary asset object with updated last_maintained_date for accurate status calculation
                            const assetWithUpdatedDate = {
                                ...this.asset,
                                last_maintained_date: { seconds: currentTime }
                            };
                            
                            storedMaintenanceStatus = calculateMaintenanceStatus(assetWithUpdatedDate, currentTime);

                            this.postedNotes = this.notes;
                            this.detailsHeader = "Submitted - Thank you!";
                            this.successClass = 'submission_success'
                        }

                        if (checkOut == false) {
                            this.$firestore.asset.update({
                                first_maintained_date: (this.asset.first_maintained_date == null ? new Date() : this.asset.first_maintained_date),
                                last_maintained_date: new Date(),
                                maintenance_current_status: passParsed,
                                maintenance_current_notes: notesParsed,
                                maintenance_current_user: this.selected.fullName,
                                maintenance_current_company: this.selected.company,
                                maintenance_status: storedMaintenanceStatus
                            }).then(() => {
                                if (passParsed === 'Fail') {
                                    const failEmailNotificationUrl = `${process.env.VUE_APP_API_URL}/send-fail-notification`;
                                    axios({
                                        method: 'post',
                                        url: failEmailNotificationUrl,
                                        data: {
                                            'reporter_name': this.selected.fullName,
                                            'reporter_company': this.selected.company,
                                            'notes': notesParsed,
                                            companyName: this.clientName,
                                            'date': moment(new Date()).format('YYYY-MM-DD @ hh:mma'),
                                            'site_id': this.$route.params.id,
                                            'asset_id': this.$route.params.asset_id
                                        }
                                    }).then(() => {
                                        this.$toast.add({
                                            severity: 'success',
                                            summary: 'Success',
                                            detail: 'Maintenance information submitted.',
                                            life: 6000
                                        });
                                    }).catch(() => {
                                        this.$toast.add({
                                            severity: 'error',
                                            summary: 'Error',
                                            detail: 'Something went wrong!',
                                            life: 3000
                                        });
                                    });
                                } else if (passParsed === 'Pass') {
                                    this.$toast.add({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: 'Maintenance information submitted.',
                                        life: 6000
                                    });
                                }
                            })

                        } else {
                            let checkinout = this.selected.checked.key;
                            if (checkinout == 'in') {
                                let path = this.$route.path.split('/');
                                let isAssetPage = 0;
                                if (path.length > 4) {
                                    isAssetPage = 1;
                                }
                                this.$router.push({ name: "checksuccess", params: { checked: checkinout, full_name: this.selected.fullName, company: this.selected.company }, query: { is_asset_page: isAssetPage } });
                            } else {
                                this.$router.push({ name: "checksuccess", params: { checked: checkinout, full_name: '#', company: '#' } });
                            }
                        }
                    });
                }
            });
        },
        storeAttendance(checkOut) {
            if (!this.isOnline) { // doublecheck if offline

                let currentDate = new Date(),
                    // parsedCurrentDate = this.parseISOString(currentDate),
                    formattedDate = moment(currentDate).format('DD/MM/YYYY @ hh:mma'),
                    assetId = this.$route.params.asset_id,
                    assetIdParsed = (typeof (assetId) !== 'undefined' ? assetId : null),
                    passParsed = (typeof (assetId) !== 'undefined' ? this.passFail : ''),
                    notesParsed = (typeof (assetId) !== 'undefined' ? this.notes : null),
                    metaParsed = (typeof (assetId) !== 'undefined' ? {
                        category: (typeof (this.offlineAssets.category) !== 'undefined' ? this.offlineAssets.category : ''),
                        make: (typeof (this.offlineAssets.make) !== 'undefined' ? this.offlineAssets.make : ''),
                        model: (typeof (this.offlineAssets.model) !== 'undefined' ? this.offlineAssets.model : ''),
                        asset_id: (typeof (this.offlineAssets.asset_id) !== 'undefined' ? this.offlineAssets.asset_id : ''),
                        description: (typeof (this.offlineAssets.description) !== 'undefined' ? this.offlineAssets.description : ''),
                        install_date: (typeof (this.offlineAssets.install_date) !== 'undefined' ? this.offlineAssets.install_date : ''),
                        warranty: (typeof (this.offlineAssets.warranty) !== 'undefined' ? this.offlineAssets.warranty : ''),
                        warranty_expiry_date: (typeof (this.offlineAssets.warranty_expiry_date) !== 'undefined' ? this.offlineAssets.warranty_expiry_date : ''),
                        area: (typeof (this.offlineAssets.area) !== 'undefined' ? this.offlineAssets.area : ''),
                        location: (typeof (this.offlineAssets.location) !== 'undefined' ? this.offlineAssets.location : '')
                    } : null),
                    status = (checkOut == false ? { name: null, key: null } : this.selected.checked);

                // Use the utility function to calculate maintenance status
                const currentTime = moment().unix();
                
                // Create a temporary asset object with updated last_maintained_date for accurate status calculation
                const assetWithUpdatedDate = {
                    ...this.offlineAssets,
                    last_maintained_date: { seconds: currentTime }
                };
                
                const storedMaintenanceStatus = calculateMaintenanceStatus(assetWithUpdatedDate, currentTime);

                let dataToStore = {
                    asset_id: this.$route.params.asset_id,
                    meta: {
                        maintenance_current_status: passParsed,
                        maintenance_current_notes: notesParsed,
                        maintenance_current_user: this.selected.fullName,
                        maintenance_current_company: this.selected.company,
                        last_maintained_date: currentDate,
                        first_maintained_date: (((this.offlineAssets.first_maintained_date == null) && this.asset.first_maintained_date == null) ? currentDate : this.offlineAssets.first_maintained_date),
                        maintenance_status: storedMaintenanceStatus
                    }
                }

                let attendanceDataToStore = {
                    full_name: this.selected.fullName,
                    company: this.selected.company,
                    client_id: this.$route.params.client_id,
                    site_id: this.$route.params.id,
                    site_name: this.offlineAssets.site_name,
                    asset_id: assetIdParsed,
                    timestamp: currentDate,
                    datetime: formattedDate,
                    checked: status,
                    fault: this.selected.fault,
                    pass: passParsed,
                    notes: notesParsed,
                    meta: metaParsed
                }

                if (this.currentStoredData) { // if there is some data already stored, push then reset
                    this.currentStoredData.push(dataToStore);
                    sessionStorage.setItem('stored-maintenance-data', JSON.stringify(this.currentStoredData));
                } else { // if nothing stored, set as empty array and push
                    let dataArrayToPush = [];
                    dataArrayToPush.push(dataToStore)
                    sessionStorage.setItem('stored-maintenance-data', JSON.stringify(dataArrayToPush));
                }

                if (this.currentStoredAttendance) { // if there is some data already stored, push then reset
                    this.currentStoredAttendance.push(attendanceDataToStore);
                    sessionStorage.setItem('stored-attendance-data', JSON.stringify(this.currentStoredAttendance));
                } else { // if nothing stored, set as empty array and push
                    let attendanceArrayToPush = [];
                    attendanceArrayToPush.push(attendanceDataToStore)
                    sessionStorage.setItem('stored-attendance-data', JSON.stringify(attendanceArrayToPush));
                }

                this.detailsHeader = "Submission Stored";
                this.successClass = 'submission_success';
                if (checkOut == false) {
                    this.$toast.add({ severity: 'warn', summary: 'Success', detail: 'Maintenance information stored. Keep this session active until you regain connection to submit this record.', life: 6000 });

                }

            }

        },
        finishedCheckOut() {
            // Used for check out button only
            // adds data to attendance log
            this.$refs.selected.validate().then(success => {

                let currentDate = new Date(),
                    formattedDate = moment(currentDate).format('DD/MM/YYYY @ hh:mma'),
                    assetId = this.$route.params.asset_id,
                    assetIdParsed = (typeof (assetId) !== 'undefined' ? assetId : null),
                    metaParsed = (typeof (assetId) !== 'undefined' ? {
                        category: (typeof (this.asset.category) !== 'undefined' ? this.asset.category : ''),
                        make: (typeof (this.asset.make) !== 'undefined' ? this.asset.make : ''),
                        model: (typeof (this.asset.model) !== 'undefined' ? this.asset.model : ''),
                        asset_id: (typeof (this.asset.asset_id) !== 'undefined' ? this.asset.asset_id : ''),
                        description: (typeof (this.asset.description) !== 'undefined' ? this.asset.description : ''),
                        install_date: (typeof (this.asset.install_date) !== 'undefined' ? this.asset.install_date : ''),
                        warranty_expiry_date: (typeof (this.asset.warranty_expiry_date) !== 'undefined' ? this.asset.warranty_expiry_date : ''),
                        area: (typeof (this.asset.area) !== 'undefined' ? this.asset.area : ''),
                        location: (typeof (this.asset.location) !== 'undefined' ? this.asset.location : '')
                    } : null);

                if (success) {
                    let attendance;
                    console.log(this.$firestore)
                    if (this.$firestore != undefined) {
                        attendance = this.$firestore.attendance
                    } else {
                        attendance = db.collection('attendance');
                    }
                    attendance.add(
                        {
                            full_name: this.selected.fullName,
                            company: this.selected.company,
                            client_id: this.$route.params.client_id,
                            site_id: this.$route.params.id,
                            site_name: this.siteName,
                            asset_id: assetIdParsed,
                            timestamp: currentDate,
                            datetime: formattedDate,
                            checked: this.selected.checked,
                            fault: '',
                            pass: '',
                            notes: '',
                            meta: metaParsed
                        }
                    ).then(() => {
                        let checkinout = this.selected.checked.key;
                        this.$router.push({ name: "checksuccess", params: { checked: checkinout, full_name: '#', company: '#' } });
                    });
                }
            });
        },
        protectedCheckOut() {
            this.$confirm.require({
                message: 'Are you sure you want to check out?',
                header: 'Check Out?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.finishedCheckOut();
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        isAsset() {
            if (typeof (this.$route.params.asset_id) !== 'undefined') {
                return true;
            } else {
                return false;
            }
        },
        isCheckedIn() {
            if (this.$cookie.get('ProAstra_checkedIn')) {
                return true;
            } else {
                return false;
            }
        },
        forceFourDigits(val) {
            // add zeroes to make it 4 digits
            if (val === null || val === undefined) {
                return '####';
            }
            var numStr = val.toString();
            while (numStr.length < 4) {
                // keep adding zeroes until length is 4
                numStr = "0" + numStr;
            }
            return numStr;
        },
        fetchCachedData() {
            const allAssets = JSON.parse(localStorage.getItem('site-asset-data'));
            allAssets.forEach((asset, index) => {
                if (asset.key == this.$route.params.asset_id) {
                    this.offlineAssets = asset;
                }
            });

            const allFaults = JSON.parse(localStorage.getItem('site-fault-data'));
            allFaults.forEach((fault, index) => {
                if (fault.asset_id == this.$route.params.asset_id) {
                    this.faults.push(fault)
                }
            });
        },
        fetchSiteName() {
            const siteNameUrl = process.env.VUE_APP_API_URL + '/init/maintenance/site-name';

            if (this.isOnline) {
                axios({
                    method: 'post',
                    url: siteNameUrl,
                    data: {
                        'siteId': this.$route.params.id,
                    }
                }).then((response) => {
                    this.siteName = response.data;
                }).catch(error => { console.error(error) });
            }
        },
        fetchCompanyName() {
            const companyNameUrl = process.env.VUE_APP_API_URL + '/init/maintenance/client-name';
            if (this.isOnline) {
                axios({
                    method: 'post',
                    url: companyNameUrl,
                    data: {
                        'clientId': this.$route.params.client_id,
                    }
                }).then((response) => {
                    this.clientName = response.data;
                }).catch(error => { console.error(error) });
            }
        },
        addFault() {

            this.notes = this.notes.replaceAll('\n', ' - ');
            this.notes = this.notes.replaceAll(',', ' - ');
            this.selected.fullName = this.selected.fullName.replaceAll(',', ' - ')
            this.selected.company = this.selected.company.replaceAll(',', ' - ')

            const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-report'

            axios({
                method: 'post',
                url: reportFaultEndpoint,
                data: {
                    // all these are required to hit this function, so shouldn't be a problem
                    'asset_id': this.$route.params.asset_id,
                    'site_id': this.$route.params.id,
                    'client_id': this.$route.params.client_id,
                    'fault_status': this.FaultStatus,
                    'notes': this.notes,
                    'reporter_name': this.selected.fullName,
                    'reporter_company': this.selected.company,
                }
            }).then((response) => {
                // console.log(response.data)
                this.postedNotes = this.notes
                this.detailsHeader = "Submitted - Thank you!"
                this.successClass = 'submission_success'
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Information Successfully Submitted.', life: 6000 });
            }).catch(error => { console.error(error) });
        },
        storeFault(checkOut) {
            // @TODO
            if (!this.isOnline) { // doublecheck if offline

                let assetId = this.$route.params.asset_id,
                    faultParsed = (typeof (assetId) !== 'undefined' ? this.FaultStatus : ''),
                    notesParsed = (typeof (assetId) !== 'undefined' ? this.notes : null);

                let dataToStore = {
                    asset_id: this.$route.params.asset_id,
                    client_id: this.$route.params.client_id,
                    site_id: this.$route.params.id,
                    fault_status: faultParsed,
                    fault_reporter_name: this.selected.fullName,
                    fault_reporter_company: this.selected.company,
                    fault_report_note: notesParsed,
                    fault_id: (this.selectedFault) ? this.selectedFault.key : null
                }

                if (this.currentStoredFaultData) { // if there is some data already stored, push then reset
                    this.currentStoredFaultData.push(dataToStore);
                    sessionStorage.setItem('stored-fault-asset-data', JSON.stringify(this.currentStoredFaultData));
                } else { // if nothing stored, set as empty array and push
                    let dataArrayToPush = [];
                    dataArrayToPush.push(dataToStore)
                    sessionStorage.setItem('stored-fault-asset-data', JSON.stringify(dataArrayToPush));
                }

                this.detailsHeader = "Submission Stored";
                this.successClass = 'submission_success';
                if (checkOut == false) {
                    this.$toast.add({ severity: 'warn', summary: 'Success', detail: 'Fault information stored. Keep this session active until you regain connection to submit this record.', life: 6000 });

                }

            }
        },
        fetchFaultData() { // this function stores all fault data against the assets in a site for offline use - in_progress only
            const fetchFaultDataEndpoint = process.env.VUE_APP_API_URL + '/fetch-in-progress-active-faults'

            if (this.isOnline) {
                axios({
                    method: 'post',
                    url: fetchFaultDataEndpoint,
                    data: {
                        'site_id': this.$route.params.id,
                    }
                }).then((response) => {
                    localStorage.setItem('site-fault-data', JSON.stringify(response.data));
                }).catch(error => { console.error(error) });
            }
        },
        updateFaultStatus(faultKey = null, faultStatus) {

            this.notes = this.notes.replaceAll('\n', ' - ');
            this.notes = this.notes.replaceAll(',', ' - ');
            this.selected.fullName = this.selected.fullName.replaceAll(',', ' - ')
            this.selected.company = this.selected.company.replaceAll(',', ' - ')

            const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-report'

            axios({
                method: 'post',
                url: reportFaultEndpoint,
                data: {
                    // all these are required to hit this function, so shouldn't be a problem
                    'asset_id': this.$route.params.asset_id,
                    'site_id': this.$route.params.id,
                    'client_id': this.$route.params.client_id,
                    'fault_status': faultStatus,
                    'notes': this.notes,
                    'reporter_name': this.selected.fullName,
                    'reporter_company': this.selected.company,
                    'fault_id': faultKey // this is the document ID, NOT the fault_id metadata
                }
            }).then((response) => {
                this.postedNotes = this.notes
                this.detailsHeader = "Submitted - Thank you!"
                this.successClass = 'submission_success'
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Information Successfully Submitted.', life: 6000 });
                this.fetchFaultData();
            }).catch(error => { console.error(error) });
        },
        areArraysEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) {
                // console.log("Arrays have different lengths.");
                return false;
            }

            // Helper function to convert objects to raw JSON representations
            const toRawObject = (obj) => {
                if (typeof obj === "object" && obj !== null) {
                    return JSON.parse(JSON.stringify(obj));
                }
                return obj;
            };

            // Convert all elements to raw objects
            const rawArr1 = arr1.map(toRawObject);
            const rawArr2 = arr2.map(toRawObject);

            // Sort both arrays
            const sortedArr1 = rawArr1.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
            const sortedArr2 = rawArr2.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

            let differences = [];

            // Compare each element
            sortedArr1.forEach((value, index) => {
                if (JSON.stringify(value) !== JSON.stringify(sortedArr2[index])) {
                    differences.push({
                        index,
                        value1: value,
                        value2: sortedArr2[index],
                    });
                }
            });

            if (differences.length > 0) {
                // console.log("Differences found:", differences);
                return false;
            }

            // console.log("Arrays are equal.");
            return true;
        },
        updateFaultData() {
            // check if fault data exists in localstorage, if so, fetch fault data via endpoint and cross reference - update if changes

            if (localStorage.getItem('site-fault-data') && this.isOnline) {
                const fetchFaultDataEndpoint = process.env.VUE_APP_API_URL + '/fetch-in-progress-active-faults'

                axios({
                    method: 'post',
                    url: fetchFaultDataEndpoint,
                    data: {
                        'site_id': this.$route.params.id,
                    }
                }).then((response) => {
                    const existingData = JSON.parse(localStorage.getItem('site-fault-data'));
                    const newData = response.data;

                    if (!this.areArraysEqual(existingData, newData)) {
                        console.log('updating faults...')
                        localStorage.removeItem('site-fault-data')
                        localStorage.setItem('site-fault-data', JSON.stringify(newData));
                        this.faults = []
                        this.fetchCachedData()
                    }
                }).catch(error => { console.error(error) });
            }

        },
        setIndividualFaultStatus(faultValue) {
            // console.log(this.current_fault_status)
            return this.fault_statuses.find(x => x.value == faultValue).label
        },
        fetchSiteCompanyData(siteName, clientName) {
            if (this.isOnline) {
                const SiteCompanyData = {
                    siteName: siteName,
                    clientName: clientName
                }
                localStorage.setItem('site-company-data', JSON.stringify(SiteCompanyData));
            }
            const SiteCompanyDataStored = JSON.parse(localStorage.getItem('site-company-data'))
            this.siteNameStored = SiteCompanyDataStored.siteName;
            this.clientNameStored = SiteCompanyDataStored.clientName;

            console.log(this.siteNameStored)
        }
    }
}
</script>

<style lang="scss">
.icon__active {
    background-color: #f31b2b;
    color: #ffeaea;
}

.icon__in_progress {
    background-color: #ffbf00;
    color: #eee;
}

.status__icon {
    padding: 2px 12px;
    border-radius: 12px;
}

.report__buttons {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    label {
        margin-bottom: 0 !important;

        &.disabled__button {
            opacity: 0.7;
            filter: grayscale(1);
            background: #80808033;

            &:hover {
                box-shadow: none;
                cursor: not-allowed;
            }
        }

        &:hover {
            box-shadow: 0 0 0 0.2rem rgba(#1f5ea4, 0.4431372549);
        }
    }
}

.fault_fields>span {
    width: 400px;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.p-dropdown-option hr {
    margin: 0.5rem 0;
}
</style>